import { render, staticRenderFns } from "./ReleaseMovementModal.vue?vue&type=template&id=307ba7a9&"
import script from "./ReleaseMovementModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseMovementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports